export const sorts = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
}

/* This represents the number of results per page that we are requesting from the API. As it currently stands we
   do not allow users to control this value, nor do we receive that information from the API. */
export const PER_PAGE = 5

// Used with redux-saga delay effect to prevent Progress Indicator from flashing on screen.
export const PROGRESS_INDICATOR_TIMEOUT = 500

/* Used as the element Id for the project results wrapper element on ProjectBoardPage. This is shared with saga
   where we are controlling scrolling behavior after search requests. */
export const RESULTS_WRAPPER_ID = 'project-results-wrapper'

export const X_ACCESS_TOKEN_COOKIE_NAME = 'rp_x_access_token'
export const X_ACCESS_TOKEN_COOKIE_DEFAULT_TTL = 86400 // Expiration in seconds
export const X_ACCESS_TOKEN_COOKIE_EXTENDED_TTL = 1209600 // Expiration in seconds ( 2 weeks )
